module.exports = __webpack_public_path__ + "media/buy-now/sample_box2-5568de8c.png";